<template>
  <div fluid>
    <v-row>
      <v-col>
        <v-checkbox v-model="selectAll" label="Select All" type="checkbox" @change="selectAllPhotos"/>
      </v-col>
    </v-row>
    <v-row>
      <v-col
          v-for="image in images"
          :key="image.id"
          :lg="6"
          :md="6"
          :sm="12"
          :xl="4"
          :xs="12"
      >
        <photo-card :editable="true" :image="image" :isQc="isQc" :isSa="isSa">
        </photo-card>

      </v-col>
    </v-row>
  </div>
</template>

<script>
import PhotoCard from './photos/PhotoCard.vue'

export default {
  name: 'PhotoListView',
  components: {
    PhotoCard
  },
  mounted() {
    // this.$props.images.forEach(image => {
    //   image.visible = false
    // })
  },
  props: {
    editable: Boolean,
    images: Array,
    isQc: {
      type: Boolean,
      default: false
    },
    isSa: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectAll: false,
    }
  },
  methods: {
    selectAllPhotos: function () {
      for (let i = 0; i < this.images.length; i++) {
        this.images[i].selected = this.selectAll
      }

    },
  }
}
</script>

<style>

</style>
